import { forwardRef } from "react"

import Input from './Input.jsx'

const Password = forwardRef(function Password({...props}, ref) {
  return (
    <Input
      ref={ref}
      placeholder="••••••••••"
      autoComplete={"current-password"}
      type={"password"}
      {...props}
    />
  )
})

export default Password;
